import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

/** The authenticated user, typed end to end by the generated contract. */
export type Me = components["schemas"]["MeResponse"];

/** GET /v1/me — current user. The bearer token is attached by the client middleware. */
export async function getMe(): Promise<Me> {
  return unwrap(await api.GET("/v1/me"));
}
